export const EMPTY_OPERATIONS_MANAGEMENT_FORM = {
  id: null,
  workflowKey: "client-to-customer-review",
  managingTeamId: "",
  reviewerUserId: "",
  appliesToTeamId: "",
  receivesEmail: true,
  receivesNotifications: true,
  canApprove: true,
  isActive: true,
};

export const normalizeId = (value) => {
  const parsed = Number.parseInt(value, 10);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : "";
};

export const buildOperationsManagementPayload = ({
  formValues = {},
  instanceUniqueId = "",
}) => {
  const managingTeamId = normalizeId(formValues.managingTeamId);
  const appliesToTeamId = normalizeId(formValues.appliesToTeamId);
  const reviewerUserId = normalizeId(formValues.reviewerUserId);
  const managedTeamId = appliesToTeamId || normalizeId(formValues.managedTeamId);

  return {
    instanceUniqueId,
    workflowKey: formValues.workflowKey || "client-to-customer-review",
    managingTeamId: managingTeamId ? Number(managingTeamId) : null,
    managedTeamId: managedTeamId ? Number(managedTeamId) : null,
    appliesToTeamId: appliesToTeamId ? Number(appliesToTeamId) : null,
    reviewerUserId: reviewerUserId ? Number(reviewerUserId) : null,
    receivesEmail: formValues.receivesEmail !== false,
    receivesNotifications: formValues.receivesNotifications !== false,
    canApprove: formValues.canApprove !== false,
    isActive: formValues.isActive !== false,
  };
};

export const getInitialOperationsManagementFormValues = (relationship = null) => ({
  ...EMPTY_OPERATIONS_MANAGEMENT_FORM,
  id: relationship?.id ?? null,
  workflowKey: relationship?.workflowKey || "client-to-customer-review",
  managingTeamId:
    relationship?.managingTeamId ||
    relationship?.managingTeam?.id ||
    "",
  reviewerUserId:
    relationship?.reviewerUserId ||
    relationship?.reviewer?.userId ||
    "",
  appliesToTeamId:
    relationship?.appliesToTeamId ||
    relationship?.managedTeamId ||
    relationship?.appliesToTeam?.id ||
    relationship?.managedTeam?.id ||
    "",
  receivesEmail: relationship?.receivesEmail !== false,
  receivesNotifications: relationship?.receivesNotifications !== false,
  canApprove: relationship?.canApprove !== false,
  isActive: relationship?.isActive !== false,
});

export const getReviewerOptionsForManagingTeam = ({
  managingTeamId,
  teams = [],
  reviewerOptions = [],
}) => {
  const normalizedManagingTeamId = normalizeId(managingTeamId);
  if (!normalizedManagingTeamId) return [];

  const managingTeam = (Array.isArray(teams) ? teams : []).find(
    (team) => Number(team?.id) === Number(normalizedManagingTeamId)
  );

  if (!managingTeam) return [];

  const allowedUserIds = new Set(
    (Array.isArray(managingTeam.memberUserIds) ? managingTeam.memberUserIds : [])
      .map((value) => normalizeId(value))
      .filter(Boolean)
      .map((value) => Number(value))
  );

  return (Array.isArray(reviewerOptions) ? reviewerOptions : []).filter((reviewer) =>
    allowedUserIds.has(Number(reviewer?.userId))
  );
};

export const reconcileReviewerUserIdForManagingTeam = ({
  managingTeamId,
  reviewerUserId,
  teams = [],
  reviewerOptions = [],
}) => {
  const normalizedReviewerUserId = normalizeId(reviewerUserId);
  if (!normalizedReviewerUserId) return "";

  const filteredReviewers = getReviewerOptionsForManagingTeam({
    managingTeamId,
    teams,
    reviewerOptions,
  });

  return filteredReviewers.some(
    (reviewer) => Number(reviewer?.userId) === Number(normalizedReviewerUserId)
  )
    ? normalizedReviewerUserId
    : "";
};
